"use client"
import { dataset, filmwebProjectId, projectId } from "@/lib/env";
import { getOrgSize } from "@/lib/getOrgSize";
import { applyCroppedSize, applyFocalPoint, doCrop } from "@/lib/imgFuncs";
import { SanityImageCrop, SanityImageHotspot } from "@/sanity/sanity.types";
import {createImageUrlBuilder} from "@sanity/image-url";
import { ImageCrop, ImageHotspot } from "@sanity/types";
import { toNumber } from "lodash";

const imgUrlBuilder = createImageUrlBuilder({ projectId, dataset });
const fwImgUrlBuilder = createImageUrlBuilder({ projectId: filmwebProjectId, dataset });

type CMSPictureSourceProps = {
    assetRef: string;
    imageHotspot?: SanityImageHotspot | ImageHotspot;
    imageCrop?: SanityImageCrop | ImageCrop;
    customCrop?: boolean;
    width: number;
    height: number;
    crop?: boolean;
    isFilmweb?: boolean;
    media: string;
};

export default function CMSPictureSource({ assetRef, width, height, crop = false, imageHotspot, imageCrop, customCrop = false, isFilmweb = false, media }: CMSPictureSourceProps) {
    const size = getOrgSize(assetRef);
    const w = toNumber(width ?? size.width);
    const h = Math.round(toNumber(height ?? (w / size.aspect)));
    const customCropAspect = w / h;

    let builder = (isFilmweb ? fwImgUrlBuilder : imgUrlBuilder)
        .image(assetRef)
        .width(w)
        .auto("format");
    if (crop) {
        builder = doCrop(builder);
    }
    builder = applyFocalPoint(builder, imageHotspot);
    builder = applyCroppedSize(builder, w, size, imageCrop, customCrop, customCropAspect);
    const url = builder.url();


    return <source srcSet={url} media={media} />
}